// extracted by mini-css-extract-plugin
module.exports = {"table":"Guidelines-module__table___1YxBG","controls":"Guidelines-module__controls___78wyp","filters":"Guidelines-module__filters___2ViEw"};